import BulkImport from "../BulkButton/BulkImport";
import BulkExport from "../BulkButton/BulkExport";
import Pagination from "../Pagination/Pagination";
import { useState } from "react";
import SearchPopup from "../../Popup/SearchPopup";

export default function Title() {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="flex flex-wrap items-center justify-between w-full mb-4">
    <div className="flex items-center gap-4">
    <h2 className="text-xl font-semibold text-gray-500">Related Service Settings
        </h2>
        <button
          className="bg-red-600 text-white px-4 py-1 rounded flex items-center gap-2"
          onClick={() => setShowModal(true)}
        >
          <span className="text-xl font-bold">+</span>
          Add Related Products
        </button>
      </div>
   <div className="flex items-center gap-4">
        <BulkImport />
        <BulkExport />
        <Pagination />
      </div>

         <SearchPopup isOpen={showModal} onClose={() => setShowModal(false)} />
         
    </div>
  );
}

